var menuanimating = false; 
jQuery(document).ready(function ($) {

	// if you give a buttonthe class "expander" it will expand and contract the element defined by its data-expand attribute
	// those expandable elements must have the class "expandable"
	// if the button has an icon and you wish to change it then
	// the button should have the following attributes data - icon1="fa-bars" data - icon2="fa-times" where icon1 is the default icon and icon2 is the opened icon
	$('.expander').click(function (event) {
		var clicked_elem = this;
		// close eveything that isn't the element we want to open
		// $('.expander').each(function (event) {
		// 		if (this != clicked_elem && $(this).is(":visible")) {
		// 		toggleExpandable(event,this,'close');
		// 	}
		// });
		// now toggle the target element
		toggleExpandable(event,this);
		return false;
	});

	function toggleExpandable(event, expander, direction = null) {
		var target = $(expander).data('expand');
		var icon1 = $(expander).data('icon1');
		var icon2 = $(expander).data('icon2');
		if (!menuanimating) {
			menuanimating = true;
			if (event) { event.stopPropagation(); }
			if (($('.' + target).is(":visible") && direction == 'close') || direction != 'close') {
				$('.' + target).slideToggle({ speed: 300 });
				$('.'+target).toggleClass("is-open");
				$('i', expander).toggleClass(icon1).toggleClass(icon2);
				$('i', expander).addClass("spin");
				setTimeout(function () {
					$('i', expander).removeClass("spin");
				menuanimating = false;
				}, 300);
			}
			
		}
	}


		// this closes an expanded item such as dropdown nav if you click anywhere outside that area
		$(document).on("click touchstart", function (e) {
			// if clicking anywhere but the expanding box or the button that triggers it
			if (
				(!$(e.target).is(".expandable") && !$(".expandable").has(e.target).length > 0 && !$(e.target).is(".expander") && !$(".expander").has(e.target).length > 0)
				|| $(e.target).is(".search_close")
			) {
				$('.expander').each(function () {
					expanding = $(this).data('expand');
					if ( $(this).is(':visible') && $('.' + expanding).is(':visible') ) {
						toggleExpandable(e,this,'close');
					}
				});
			}
		});

});